var FSGrid = {};
export default FSGrid;

/** @type {Array} */
FSGrid.bulkActionRequestPool = [];

FSGrid.init = function ()
{
    $('.fs-grid').each(function()
    {
        var id = '#' + $(this).attr('id');

        // columns draggable
        FSGrid.removeEmptyActions(id);

        // columns draggable
        FSGrid.initColumnsDraggable(id);

        // columns resizable
        FSGrid.initColumnsResizable(id);

        // modal action
        FSGrid.initModalAction(id);

        // bulk action
        FSGrid.initBulkAction(id);

        // handle confirm action
        FSGrid.initHandleConfirmAction(id);

        // init filters
        FSGrid.initFilters(id);

        // bulk without dialog
        FSGrid.initBulkActionWithoutDialog(id);

        // highlighting row
        FSGrid.highlightingRow(id);

        // header and action column fixed
        FSGrid.initTableFixer(id);

        // checkboxes
        FSGrid.initCheckboxes(id);
    });
};

/**
 * @param gridId
 */
FSGrid.removeEmptyActions = function(gridId)
{
    var actions = $($(gridId + ' .grid-action-icons > span')[0]).children();
    var actionsCount = actions.length;

    for (var action = actionsCount; action > 0; action-- )
    {
        if ($(actions[action-1]).html()) continue;

        if ($(gridId + ' .grid-action-icons > span > :nth-child('+action+'):not(:empty)').length == 0){
            $(gridId + ' .grid-action-icons > span > :nth-child('+action+')').remove();
        }
    }
};

/**
 * @param gridId
 */
FSGrid.initCheckboxes = function(gridId)
{
    $(gridId + ' table').checkboxes('range', true);
};

/**
 * @param gridId
 */
FSGrid.initTableFixer = function(gridId)
{
    var config = $(gridId).data('clientsideconfig');
    if(config && config.tableFixer)
    {
        var bulkAction = config.bulkAction;
        var otherAction = config.otherAction;
        var opt = {};

        if(bulkAction && otherAction)
        {
            opt.left = 2;
        }

        if((bulkAction && !otherAction) || (!bulkAction && otherAction))
        {
            opt.left = 1;
        }

        $(gridId + ' table').tableHeadFixer(opt);
    }
};


/**
 * @param gridId
 */
FSGrid.highlightingRow = function(gridId)
{
    var _state = sessionStorage.getItem('gridCurrentRow');
    if(_state != null)
    {
        var state = JSON.parse(_state);
        if(state.enabled)
        {
            FSGrid.removeHighlightingRow(state.idRow, state.backgroundColor);
            FSGrid.addHighlightingRow(state.idRow);
            state.enabled = false;
            sessionStorage.setItem('gridCurrentRow', JSON.stringify(state));
        }
        else
        {
            sessionStorage.removeItem('gridCurrentRow');
        }
    }

    $(document).on('click',gridId + " tr[class^=grid-row-] > td", function()
    {
        var trEl = $(this).parents("tr[class^=grid-row]");
        var classVal = trEl.attr('class').match(/grid-row-[\d]+/g);

        if(classVal.length > 0)
        {
            var primaryKey = classVal[0].replace(/grid-row-/, '');
            var idRow = gridId + " tr[class=grid-row-" + primaryKey + "]";
            var backgroundColor = $(idRow).css('background-color');
            var state = {
                idRow: idRow,
                backgroundColor: backgroundColor,
                enabled: true
            };

            // remove prev highlighting row
            var _oldState = sessionStorage.getItem('gridCurrentRow');
            if(_oldState != null)
            {
                var oldState = JSON.parse(_oldState);
                FSGrid.removeHighlightingRow(oldState.idRow, oldState.backgroundColor);
                sessionStorage.removeItem('gridCurrentRow');
            }

            FSGrid.addHighlightingRow(state.idRow);
            sessionStorage.setItem('gridCurrentRow', JSON.stringify(state));
        }
    });
};

/**
 * @param idRow
 */
FSGrid.addHighlightingRow = function(idRow)
{
    $(idRow).css('background-color', '#E7F2FB');
};

/**
 * @param idRow
 * @param backgroundColor
 */
FSGrid.removeHighlightingRow = function(idRow, backgroundColor)
{
    $(idRow).css('background-color', backgroundColor);
};

/**
 * Setup columns resizable.
 */
FSGrid.initColumnsResizable = function(gridId)
{
    // https://mottie.github.io/tablesorter/docs/example-widget-resizable.html
    var config = $(gridId).data('clientsideconfig');

    if(config && config.columnsResizable == true)
    {
        $(gridId + ' table').tablesorter({
            widgets: ['resizable'],
            widgetOptions: {
                resizable_addLastColumn: true,
                resizable : true,
            }
        });
    }
};

/**
 * Setup columns draggable.
 */
FSGrid.initColumnsDraggable = function(gridId)
{
    var config = $(gridId).data('clientsideconfig');

    if(config && config.columnsDraggable == true)
    {
        $(gridId + ' table').dragtable({
            excludeFooter: true,
            persistState: config.columnsDraggablePersistUrl
        });
    }
};

/**
 * Action modal
 */

FSGrid.initModalAction = function(gridId)
{
    $(document).on('click', gridId + ' .grid-action-btn', function()
    {
        FSGrid.processModalAction(gridId, $(this).data('handleonclick'), $(this).data('target'));
    });
};

FSGrid.processModalAction = function(gridId, url, modalTarget)
{
  var modalFade = $(modalTarget);
    var modalDialog = modalFade.find('.modal-dialog');
    

    // prepare Ajax request
    var req =
    {
        url: url,
        beforeSend: function()
        {
          modalDialog.html('<div/>');
          waiter_open('large');
        },
        success: function(data, textStatus, jqXHR)
        {
            if (jqXHR.responseJSON)
            {
                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
                modalFade.modal('hide');
            }
            else
            {
                modalDialog.html(data);
                modalFade.modal('handleUpdate');
                FSForms.init();
            }
        },
        error: function(data, textStatus, jqXHR)
        {
            flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
            modalFade.modal('hide');
        },
        statusCode:
        {
            500: function()
            {
                flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
            }
        },
        complete: function(jqXHR, textStatus)
        {
            waiter_close();
        }
    };

    // send Ajax request
    $.ajax(req);
};

/** BULK ACTIONS ******************************************************************************************************/

/**
 * Inits bulk action for grid with id.
 * @param id
 */
FSGrid.initBulkAction = function(gridId)
{
    if (!$(gridId + ' .grid-bulk-action-head').length) return;

    $(gridId + ' .grid-bulk-action-head').click(FSGrid.onClickHeadCheckbox); // add event on head checkbox
    $(gridId + ' .grid-bulk-action-cell').change(FSGrid.onClickCellCheckbox); // add event on cell checkbox
    $(gridId + '-bulk-action-dialog .btn-close').click(FSGrid.onClickButtonClose); // add event on button close on dialog
    $('#sidebarRight-sidebar .btn-close').click(FSGrid.onClickButtonClose); // add event on button close on dialog
    $('#sidebarRight-sidebar-close-button').click(FSGrid.onClickButtonCloseSidebar); // add event on button close on dialog
    $(gridId + '-bulk-action-dialog .btn-min').click(FSGrid.onClickButtonMin); // add event on button min on dialog
    $(gridId + '-bulk-action-dialog .btn-link').click(FSGrid.onClickButtonLock); // add event on button lock on dialog
    $('#sidebarRight-sidebar-unlock-button').click(FSGrid.onClickButtonUnlock); // add event on button unlock on dialog
    $('.grid-actionBulkAction').click(FSGrid.onClickButtonActionMobile); // add event on button lock on dialog
    $(gridId + '-bulk-action-dialog').resize(FSGrid.updateMaxHeight);
    $(document).on('click', '.bulk_dialog_show_hide_panel_button', FSGrid.bulkDialogPanelSwitch);
    $(document).on('click', '.grid-bulk-content .bulk-form-button .ribbon-button', FSGrid.bulkFormButtonClick);

    // prepare bulk request pull
    if(Array.isArray(FSGrid.bulkActionRequestPool[gridId]) == false)
    {
        FSGrid.bulkActionRequestPool[gridId] = [];
    }

    // TODO: load state dialog after refresh
    FSGrid.removeState(gridId);
};

/**
 * This method open bulk dialog and send AJAX request.
 * @param gridId
 */
FSGrid.processBulkAction = function(gridId)
{
    var state = this.loadState(gridId);

    if(state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'close')
    {
        this.refreshDialogByDilogState('open', gridId);
        this.sendBulkActionRequest(gridId);
    }
    else if(state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'min')
    {
        this.refreshDialogByDilogState('max', gridId);
        this.sendBulkActionRequest(gridId);
    }
    if(state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'open')
    {
        this.sendBulkActionRequest(gridId);
    }
    else if(state.bulkAction.selectedRows.length == 0)
    {
        this.refreshDialogByDilogState('close', gridId);
        this.removeState(gridId);
        FSGrid.abortAllBulkActionRequest(gridId);
    }
};

/**
 * This method open/close parts of bulk dialog.
 * @param gridId
 */
FSGrid.bulkDialogPanelSwitch = function()
{
    var target = $(this).data('target');
    var id = $(this).data('bulkstate');
    var bulk_state = JSON.parse(window.sessionStorage.getItem('bulk_state')) || new Object();

    if (target){
        var area = $('#'+$(this).data("target"));
    }else{
        var area = $(this).parent().parent().find(".panel-body");
    }

    area.toggle();
    $(this).children('span').toggleClass('glyphicon-chevron-down');
    $(this).children('span').toggleClass('glyphicon-chevron-up');

    bulk_state[id] = area.is(':visible');
    window.sessionStorage.setItem('bulk_state', JSON.stringify(bulk_state));
};

/**
 * This method open/close parts of bulk dialog from memory.
 * @param gridId
 */
FSGrid.bulkDialogPanelSwitchInit = function()
{
    var bulk_state = JSON.parse(window.sessionStorage.getItem('bulk_state')) || [];

    $('.bulk_dialog_show_hide_panel_button').each(function()
    {
        var id = $(this).data('bulkstate');

        if (typeof bulk_state[id] != 'undefined' && bulk_state[id] == false){
            $(this).trigger('click');
        }
    });
};

/**
 * @param {String} state
 * @param {String} gridId
 */
FSGrid.refreshDialogByDilogState = function(stateDialog, gridId)
{
    var state = this.loadState(gridId);
    var dialog = $(gridId + '-bulk-action-dialog');

    // open dialog
    if(stateDialog == 'open')
    {
        $('.grid-actionBulkAction').removeClass('hidden');

        if (this.loadSidebarState(gridId) == true){
            var title = dialog.find('.panel-title').text();
            $('#vertical_right_text_sidebar strong').text(title);
            $('#sidebarRight-sidebar-title strong').text(title);

            showSidebarRight();
            return;
        }

        dialog.css(state.bulkAction.css);
        dialog.draggable({
            cancel: '.draggableOff'
        });
        dialog.resizable({
            handles: 'all',
            create: function(event, ui)
            {
                $('.ui-icon-gripsmall-diagonal-se').remove();
            }
        });

        // set icon
        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');

        state.bulkAction.state = 'open';
        this.saveState(gridId, state);

        this.updateMaxHeightById(gridId);
        dialog.show('slow');
    }
    // close dialog
    else if (stateDialog == 'close')
    {
        dialog.find('.panel-body').html('');
        $('.grid-actionBulkAction').addClass('hidden');
        $('#sidebarRight-sidebar').removeClass('sidebarRight-sidebar-visible');
        $('#sidebarLeft-sidebar').removeClass('responsive-hidden');
        $('#sidebarLeft-content').removeClass('responsive-hidden');

        if (this.loadSidebarState(gridId) == true){
            hideSidebarRight();
            return;
        }

        var css = {
            'position': dialog.css('position'),
            'bottom': dialog.css('bottom'),
            'right': dialog.css('right'),
            'height': dialog.css('height'),
            'width': dialog.css('width'),
            'min-height': dialog.css('min-height'),
            'min-width': dialog.css('min-width'),
            'margin-right': dialog.css('margin-right'),
            'z-index': dialog.css('z-index'),
        };

        state.bulkAction.css = css;
        state.bulkAction.state = 'close';
        this.saveState(gridId, state);

        dialog.hide('slow');
    }
    // min
    else if (stateDialog == 'min')
    {
        var prevCSS = {
            'position': dialog.css('position'),
            'bottom': dialog.css('bottom'),
            'right': dialog.css('right'),
            'height': dialog.css('height'),
            'width': dialog.css('width'),
            'min-height': dialog.css('min-height'),
            'min-width': dialog.css('min-width'),
            'margin-right': dialog.css('margin-right'),
            'z-index': dialog.css('z-index'),
        };

        // invert color
        dialog.children('.panel-heading').addClass('panel-heading-closed');

        // change icon
        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-up"></span>');

        // hide panel body
        dialog.children('.panel-body').hide();

        // disable resizable
        dialog.resizable('destroy');

        // css
        var height = dialog.children('.panel-heading').outerHeight() + 1;
        dialog.css({
            'top': '',
            'right': 0,
            'bottom': 0,
            'left': '',
            'height': height,
            'min-height': height,
        });

        state.bulkAction.css = prevCSS;
        state.bulkAction.state = 'min';
        this.saveState(gridId, state);
    }
    // max
    else if (stateDialog == 'max')
    {
        // invert color
        dialog.children('.panel-heading').removeClass('panel-heading-closed');

        // change icon
        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');

        // show panel body
        dialog.children('.panel-body').show();

        var css = state.bulkAction.css;
        css.right = 0; // fix
        css.bottom = 0; // fix
        dialog.css(css); // fix
        dialog.resizable({
            handles: 'all',
            create: function(event, ui)
            {
                $('.ui-icon-gripsmall-diagonal-se').remove();
            }
        });

        state.bulkAction.state = 'open';
        this.saveState(gridId, state);
    }
}

/** Bulk action - handles - begin *************************************************************************************/

/**
 * Callback on click head checkbox.
 */
FSGrid.onClickHeadCheckbox = function()
{
    var gridId = FSGrid.getGridId($(this));
    $(gridId + ' .grid-bulk-action-cell').prop('checked', $(this).prop('checked')); // toggle checked cell checkboxs
    FSGrid.processBulkAction(gridId);
};

/**
 * Callback on click checkbox in cell.
 */
FSGrid.onClickCellCheckbox = function()
{
    FSGrid.processBulkAction(FSGrid.getGridId($(this)));
};

/**
 * Callback on click button close in bulk dialog.
 */
FSGrid.onClickButtonClose = function()
{
    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
    FSGrid.refreshDialogByDilogState('close', gridId);
    $(gridId + ' .grid-bulk-action-cell:checked').prop('checked', false);
    $(gridId + ' .grid-bulk-action-head:checked').prop('checked', false);

    // remove highlighting row
    var _state = sessionStorage.getItem('gridCurrentRow');
    if(_state != null)
    {
        var state = JSON.parse(_state);
        FSGrid.removeHighlightingRow(state.idRow, state.backgroundColor);
        sessionStorage.removeItem('gridCurrentRow');
    }
};

/**
 * Callback on click button close in sidebar dialog.
 */
FSGrid.onClickButtonCloseSidebar = function()
{
    $('.grid-bulk-action-dialog .btn-close').trigger('click');
};

/**
 *
 */
FSGrid.onClickButtonMin = function()
{
    var gridId = FSGrid.getGridId($(this));
    var state = FSGrid.loadState(gridId);

    if(state.bulkAction.state == 'open')
    {
        FSGrid.refreshDialogByDilogState('min', gridId);
    }

    if(state.bulkAction.state == 'min')
    {
        FSGrid.refreshDialogByDilogState('max', gridId);
    }
};

/**
 *
 */
FSGrid.onClickButtonLock = function()
{
    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
    var state = FSGrid.loadState(gridId);
    FSGrid.refreshDialogByDilogState('close', gridId);
    FSGrid.saveSidebarState(gridId, true);
    FSGrid.refreshDialogByDilogState('open', gridId);
    FSGrid.sendBulkActionRequest(gridId);
};

/**
 *
 */
FSGrid.onClickButtonActionMobile = function()
{
    FSGrid.onClickButtonLock();
    $('#sidebarRight-sidebar').addClass('sidebarRight-sidebar-visible');
    $('#sidebarLeft-sidebar').addClass('responsive-hidden');
    $('#sidebarLeft-content').addClass('responsive-hidden');
};

/**
 *
 */
FSGrid.onClickButtonUnlock = function()
{
    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
    var state = FSGrid.loadState(gridId);
    FSGrid.refreshDialogByDilogState('close', gridId);
    FSGrid.saveSidebarState(gridId, false);
    FSGrid.refreshDialogByDilogState('open', gridId);
    FSGrid.sendBulkActionRequest(gridId);
};

/**
 *
 */
FSGrid.addBulkActionsCloseButton = function()
{
    $('#sidebarRight-sidebar-title .bulk_dialog_show_hide_panel_button').remove();
    if ($('#sidebarRight-sidebar-content #bulk_actions').length > 0){
        $('#sidebarRight-sidebar-title').append('<div class = "bulk_dialog_show_hide_panel_button close" data-bulkstate = "bulk_actions" data-target = "bulk_actions"><span class="bulk_edit_form bulk_dialog_show_hide_panel_glyphicon glyphicon glyphicon-chevron-up"></span></div>');
    }
};

/**
 *
 */
FSGrid.updateMaxHeight = function()
{
    FSGrid.updateMaxHeightById(FSGrid.getGridId($(this)));
};

/**
 *
 */
FSGrid.updateMaxHeightById = function(gridId)
{
    $(gridId + '-bulk-action-dialog > .panel-body').css('max-height',$(gridId + '-bulk-action-dialog').height()-$('.grid-bulk-action-dialog > .panel-heading').outerHeight()+'px');
    $(gridId + '-bulk-action-dialog > .panel-body').css('overflow','auto');

    if (isLayoutMobile()){
        $('#sidebarRight-sidebar').children('.panel-default').height('auto');
        $('#sidebarRight-sidebar-content').css('max-height', 'none');
    }else{
        var height = $('#container-fluid-main').height() - 7;
        $('#sidebarRight-sidebar').children('.panel-default').height(height-2);
        $('#sidebarRight-sidebar-content').css('max-height',height-$('#sidebarRight-sidebar-title').outerHeight()-3+'px');
    }
};
/** Bulk action - handles - end ***************************************************************************************/

/**
 * Sends Ajax request for bulk action.
 * @param gridId
 * @param dialogId
 * @param primaryKeys
 */
FSGrid.sendBulkActionRequest = function(gridId)
{
    var state = FSGrid.loadState(gridId);
    var target = (FSGrid.loadSidebarState(gridId) == true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body');
    var unTarget = (FSGrid.loadSidebarState(gridId) !== true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body');

    if(state.bulkAction.selectedRows.length == 0)
    {
        FSGrid.refreshDialogByDilogState('close', gridId);
        $(gridId + ' .grid-bulk-action-cell:checked').prop('checked', false);
        $(gridId + ' .grid-bulk-action-head:checked').prop('checked', false);
        return;
    }

    // abort all prev request
    FSGrid.abortAllBulkActionRequest(gridId);

    // prepare Ajax request
    var req =
    {
        method: 'POST',
        url: $(gridId + '-bulk-action-dialog').data('handleonclick'),
        data: state,
        beforeSend: function(jqXHR)
        {
            // adds current request into pool
            FSGrid.bulkActionRequestPool[gridId].push(jqXHR);

            // spin
            $(target).html('<div/>');
            $(unTarget).html('<div/>');
            waiter_open('medium',target);

            FSGrid.updateMaxHeightById(gridId);
        },
        success: function(data, textStatus, jqXHR)
        {
            waiter_close();
            if (jqXHR.responseJSON)
            {
                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
                $(gridId + '-bulk-action-dialog .btn-close').click();
            }
            else
            {
                $(target).html(data);
                $(target).find('form').each(function() {
                    window.Nette.initForm(this);
                });
                FSGrid.bulkDialogPanelSwitchInit();
                FSGrid.updateMaxHeightById(gridId);
            }
            FSGrid.addBulkActionsCloseButton();
        },
        error: function(jqXHR)
        {
            if(jqXHR.statusText == 'abort')
            {
                return;
            }
            else if ($(gridId + '-bulk-action-dialog').data('errormsg'))
            {
                flashMessageWarning($(gridId + '-bulk-action-dialog').data('errormsg'));
                $(gridId + '-bulk-action-dialog .btn-close').click();
            }
        },
        statusCode:
        {
            500: function()
            {
                flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
            }
        },
    };

    // send Ajax request
    $.ajax(req);
};

/**
 * Aborts all request for bulk action.
 * @param dialogId
 */
FSGrid.abortAllBulkActionRequest = function(dialogId)
{
    FSGrid.bulkActionRequestPool[dialogId].forEach(function(jqXHR, index)
    {
        jqXHR.abort();
        FSGrid.bulkActionRequestPool[dialogId].splice(index, 1);
    });
};

/** Helpers ***********************************************************************************************************/

/**
 * @param {jQuery} el
 * @returns {string}
 */
FSGrid.getGridId = function(el)
{
    return '#' + el.parents('.fs-grid').attr('id');
}

/**
 * Saves grid state in session strorage.
 * @param gridId
 */
FSGrid.saveState = function(gridId, state)
{
    window.sessionStorage.setItem(gridId, JSON.stringify(state));
};

/**
 * Saves sidebar state in session strorage.
 * @param gridId
 */
FSGrid.saveSidebarState = function(gridId, state)
{
    window.sessionStorage.setItem(gridId+'sidebar', state);
};

/**
 * Loads sidebar state from session strorage.
 * @param gridId
 */
FSGrid.loadSidebarState = function(gridId)
{
    return window.sessionStorage.getItem(gridId+'sidebar') == 'true';
};

/**
 * Loads grid state from session storage.
 * @param gridId
 * @return Object
 */
FSGrid.loadState = function(gridId)
{
    var stringState = window.sessionStorage.getItem(gridId);

    if(stringState == null)
    {
        var state = {
            bulkAction:
            {
                gridId: gridId,
                state: 'close',
                css:
                {
                    'position': 'fixed',
                    'bottom': 0,
                    'right': 0,
                    'height': $(gridId + '-bulk-action-dialog').data('height'),
                    'width': $(gridId + '-bulk-action-dialog').data('width'),
                    'min-height': $(gridId + '-bulk-action-dialog').data('minheight'),
                    'min-width': $(gridId + '-bulk-action-dialog').data('minwidth'),
                    'margin-right': '10px',
                    'z-index': 1041
                }
            }
        };
    }
    else
    {
        var state = JSON.parse(stringState);
    }

    // selected rows
    state.bulkAction.selectedRows = [];
    $(gridId + ' .grid-bulk-action-cell:checked').each(function()
    {
        state.bulkAction.selectedRows.push($(this).data('primarykey'));
    });

    return state;
};

/**
 * @param {String} gridId
 */
FSGrid.removeState = function(gridId)
{
    window.sessionStorage.removeItem(gridId);
};

/** HANDLE CONFIRM ACTIONS ********************************************************************************************/

/**
 * @param string gridId
 */
FSGrid.initHandleConfirmAction = function(gridId){
    var options = {};
    $(gridId + ' .grid-cell-action-confirm-handle').popover(options);
};

/** INIT FILTERS ********************************************************************************************/
FSGrid.initFilters = function(gridId)
{
    var config = $(gridId).data('clientsideconfig');
    if(config && config.filterBefore == true)
    {
        $('.advancedFilter').modal('show');
    }
};

/** Bulk action without dialog - start ********************************************************************************/
FSGrid.initBulkActionWithoutDialog = function(gridId)
{
    // toggle checked cell checkboxs
    $(gridId + ' .action-bulk-without-dialog-head-cell').click(function()
    {
        $(gridId + ' .action-bulk-without-dialog-body-cell').prop('checked', $(this).prop('checked'));
    });

    // handle button form multi actions
    $(gridId + ' .action-bulk-without-dialog-multi-actions-send-btn').click(function()
    {
        // selected rows
        var ids = FSGrid.bulkActionWithoutDialogGetIds(gridId);

        // link for action
        var link = $(gridId + ' .action-bulk-without-dialog-multi-actions-select-action').val();

        // redirect
        if(ids.length != 0)
        {
            window.location.replace(link + '&' + $.param({ids: ids}))
        }
        else
        {
            alert('Není vybrán žádný řádek.');
        }
    });

    // handle button form single action
    $(gridId + ' .action-bulk-without-dialog-single-action').click(function()
    {
        // selected rows
        var ids = FSGrid.bulkActionWithoutDialogGetIds(gridId);

        // link for action
        var link = $(gridId + ' .action-bulk-without-dialog-single-action').data('link');

        // redirect
        if(ids.length != 0)
        {
            window.location.replace(link + '&' + $.param({ids: ids}))
        }
        else
        {
            alert('Není vybrán žádný řádek.');
        }
    });
};

/**
 * @param gridId
 * @return {Array}
 */
FSGrid.bulkActionWithoutDialogGetIds = function(gridId)
{
    var ids = [];
    $(gridId + ' .action-bulk-without-dialog-body-cell:checked').each(function()
    {
        ids.push($(this).data('primarykey'));
    });

    var memoryId = $('#rememberSelectedId').val();
    if (memoryId){
        var memoryIDs = FSGrid.getRememberSelectedIDs(memoryId);
        for (var key in memoryIDs){
            ids.push(key);
        }
    }
    
    return ids;
};
/** Bulk action without dialog - end **********************************************************************************/

/** Helpers ***********************************************************************************************************/

/**
 * @param string gridId
 */
FSGrid.showSpin = function(gridId)
{
    //$(gridId).spin();
    waiter_open('medium',gridId + '-bulk-action-dialog .panel-body');
    $(gridId + '-content').css('opacity', '0.5');
};

/**
 * @param string gridId
 */
FSGrid.hideSpin = function(gridId)
{
    //$(gridId).spin(false);
    waiter_close();
    $(gridId + '-content').css('opacity', '1');
};

/**
 *
 */
FSGrid.bulkFormButtonClick = function(event)
{
    event.preventDefault();
    $(this).closest('form').submit();
};

/** REMEMBER SELECTED ROWS THROUGH ALL PAGES *************************************************************************/

/**
 * Clean memory
 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
 */
FSGrid.rememberSelectedClean = function(gridId)
{
    window.localStorage.removeItem(gridId + '.rememberSelected');
};

/**
 * Init memory
 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
 */
FSGrid.rememberSelectedInit = function(gridId)
{
    $( window ).unload(function() {
        var items = window.localStorage.getItem(gridId + '.rememberSelected');
        if (items){
            items = JSON.parse(items);
        }else{
            items = {};
        }
        $('#' + gridId + ' input[data-primarykey]').each(function(){
            var primaryKey = $(this).data('primarykey');
            if ($(this).is(':checked')){
                items[primaryKey] = primaryKey;
            }else{
                delete items[primaryKey];
            }
        });

        window.localStorage.setItem(gridId + '.rememberSelected', JSON.stringify(items));
    });

    var items = window.localStorage.getItem(gridId + '.rememberSelected');
    if (items){
        items = JSON.parse(items);
        for (var primaryKey in items){
            $('#' + gridId + ' input[data-primarykey='+primaryKey+']').prop('checked', true);
        }
    }

    var grid = $('#' + gridId + '.fs-grid').length ?  $('#' + gridId + '.fs-grid') : $('#' + gridId + ' .fs-grid');
    grid.append('<input type="hidden" id="rememberSelectedId" value="'+gridId + '">');
};

/**
 * Get count
 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
 * @returns count
 */
FSGrid.getRememberSelectedCount = function(gridId)
{
    var items = window.localStorage.getItem(gridId + '.rememberSelected');
    if (items){
        items = JSON.parse(items);
        return Object.keys(items).length;
    }else{
        return 0;
    }
};

/**
 * Get rememembered IDs
 * @param gridId
 * @returns {}
 */
FSGrid.getRememberSelectedIDs = function(gridId)
{
    var items = window.localStorage.getItem(gridId + '.rememberSelected');
    if (items){
        return JSON.parse(items);
    }else{
        return {};
    }
};


// WEBPACK FOOTER //
// ./client-side/Grid/js/grid.js